import { render, staticRenderFns } from "./CatalogItems.vue?vue&type=template&id=0c79da5d"
import script from "./CatalogItems.vue?vue&type=script&lang=js"
export * from "./CatalogItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports